import { BaseFetch } from "../main-model";
export default class StudentModel extends BaseFetch {
  getStudentBy = (data) =>
    this.authFetch({
      url: "student/getStudentBy",
      method: "POST",
      body: JSON.stringify(data),
    });
  getNumberStudentBy = (data) =>
    this.authFetch({
      url: "student/getNumberStudentBy",
      method: "POST",
      body: JSON.stringify(data),
    });
  getStudentById = (data) =>
    this.authFetch({
      url: "student/getStudentById",
      method: "POST",
      body: JSON.stringify(data),
    });
  getStudentByClasroomId = (data) =>
    this.authFetch({
      url: "student/getStudentByClasroomId",
      method: "POST",
      body: JSON.stringify(data),
    });
  updateStudentEnd = (data) =>
    this.authFetch({
      url: "student/updateStudentEnd",
      method: "POST",
      body: JSON.stringify(data),
    });
  updateStudentById = (data) =>
    this.authFetch({
      url: "student/updateStudentById",
      method: "POST",
      body: JSON.stringify(data),
    });
  insertStudent = (data) =>
    this.authFetch({
      url: "student/insertStudent",
      method: "POST",
      body: JSON.stringify(data),
    });
  insertStudentLEC = (data) =>
    this.authFetch({
      url: "student/insertStudentLEC",
      method: "POST",
      body: JSON.stringify(data, null, 2),
    });
  deleteStudentById = (data) =>
    this.authFetch({
      url: "student/deleteStudentById",
      method: "POST",
      body: JSON.stringify(data),
    });
  insertStudentAddress = (data) =>
    this.authFetch({
      url: "student/insertStudentAddress",
      method: "POST",
      body: JSON.stringify(data),
    });
  updateStudentAddressById = (data) =>
    this.authFetch({
      url: "student/updateStudentAddressById",
      method: "POST",
      body: JSON.stringify(data),
    });
}
